import React, { useEffect, useState } from 'react';
type SuccessConfettiProps = {
  trigger: boolean;
};
export function SuccessConfetti({
  trigger
}: SuccessConfettiProps) {
  const [particles, setParticles] = useState<Array<{
    id: number;
    x: number;
    y: number;
    color: string;
    delay: number;
  }>>([]);
  useEffect(() => {
    if (trigger) {
      const colors = ['#4ade80', '#22c55e', '#16a34a', '#15803d', '#86efac'];
      const newParticles = Array.from({
        length: 30
      }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 0.3
      }));
      setParticles(newParticles);
      setTimeout(() => setParticles([]), 2000);
    }
  }, [trigger]);
  if (particles.length === 0) return null;
  return <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden" data-id="element-2596">
      {particles.map(particle => <div key={particle.id} className="absolute w-2 h-2 rounded-full animate-confetti" style={{
      left: `${particle.x}%`,
      top: `${particle.y}%`,
      backgroundColor: particle.color,
      animationDelay: `${particle.delay}s`,
      animation: 'confetti 1.5s ease-out forwards'
    }} data-id="element-2597" />)}
      <style data-id="element-2598">{`
        @keyframes confetti {
          0% {
            transform: translateY(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>;
}